<template>
  <HomeLearnSkeletonLoader v-if="loading" />
  <section
    v-else
    class="home-learn-container pb-5"
    aria-label="Learn"
  >
    <div class="learn-header">
      <div class="learn-tab">
        Learn
      </div>
    </div>
    <div class="mt-3 learn-cards">
      <HomeLearnCard
        v-for="({
          title, description, link, imgSrc,
        }, i) in learnCards"
        :key="title"
        :class="{ 'mr-4': i !== learnCards.length - 1 }"
        :title="title"
        :description="description"
        :link="link"
        :img-src="imgSrc"
      />
    </div>
  </section>
</template>

<script>
import HomeLearnCard from '@/components/home/HomeLearnCard.vue';
import { useHome } from '@/stores/home/home';
import { mapState } from 'pinia';
import HomeLearnSkeletonLoader from '@/components/home/HomeLearn/HomeLearnSkeletonLoader.vue';

export default {
  name: 'HomeLearn',
  components: {
    HomeLearnCard,
    HomeLearnSkeletonLoader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useHome, ['learnCards']),
  },
};
</script>

<style lang="less" scoped>
.home-learn-container {
  width: 690px;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.learn-header {
  width: 100%;
}

.learn-tab {
  width: 186px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 16px;
  background: fade(@grey-400, 20%);
  font-size: 16px;
  font-weight: 700;
  color: @text-darkest;
}

.learn-line {
  width: 654px;
  height: 1px;
  background: linear-gradient(to right, @grey-900, @white);
  position: absolute;
  left: 36px;
  bottom: 0px;
}

.learn-cards {
  width: 690px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
</style>
